module.exports = __webpack_public_path__ + "img/custom_media_activity_ba.bf8d3d02.png";